/*
 * Ürün detayı: teslimat tarihi / kargo geri sayımı / son X adet (snippets/bup-delivery-stock.liquid)
 * ve "Stoğa gelince haber ver" müşteri formu (snippets/bup-back-in-stock.liquid).
 */
(function () {
  if (window.bupPdpProofLoaded) return;
  window.bupPdpProofLoaded = true;

  var TZ = 'Europe/Istanbul';
  var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  // Şu anki İstanbul saati; tarih aritmetiği UTC gün değerleri üzerinden yapılır.
  function istanbulNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = parseInt(p.value, 10); });
    return parts;
  }

  // Tema ayarları > Kargo tatilleri: "28.10.2026" biçimindeki tarihleri UTC gün değerlerine çevirir.
  function parseHolidays(text) {
    var days = [];
    (text || '').replace(/(\d{1,2})\.(\d{1,2})\.(\d{4})/g, function (m, d, mo, y) {
      days.push(Date.UTC(+y, +mo - 1, +d));
    });
    return days;
  }

  function isOffDay(date, skip, holidays) {
    if (holidays && holidays.indexOf(date.getTime()) !== -1) return true;
    var d = date.getUTCDay();
    if (skip === 'weekend') return d === 0 || d === 6;
    if (skip === 'sunday') return d === 0;
    return false;
  }

  function addWorkDays(date, days, skip, holidays) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (!isOffDay(d, skip, holidays)) days--;
    }
    return d;
  }

  // odsport giesto-delivery-timeline ile aynı biçim: "12 Ekim" / "12 Ekim - 13 Ekim"
  function formatDay(d) { return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; }
  function formatRange(a, b) {
    return a.getTime() === b.getTime() ? formatDay(a) : formatDay(a) + ' - ' + formatDay(b);
  }

  function updateDelivery(root) {
    var min = parseInt(root.dataset.minDays, 10) || 0;
    var max = Math.max(parseInt(root.dataset.maxDays, 10) || 0, min);
    var cutoff = parseInt(root.dataset.cutoff, 10);
    var skip = root.dataset.skip;
    var holidays = root.bupHolidays || (root.bupHolidays = parseHolidays(root.dataset.holidays));
    var now = istanbulNow();
    var today = new Date(Date.UTC(now.year, now.month - 1, now.day));

    // Kesim saatinden önce ve iş günüyse bugün kargoda, değilse bir sonraki iş günü.
    var shipsToday = !isOffDay(today, skip, holidays) && now.hour < cutoff;
    var shipDay = shipsToday ? today : addWorkDays(today, 1, skip, holidays);
    var text = formatRange(addWorkDays(shipDay, min, skip, holidays), addWorkDays(shipDay, max, skip, holidays));

    var box = root.bupBox || root;
    box.querySelectorAll('[data-bup-date]').forEach(function (el) { el.textContent = text; });
    box.querySelectorAll('[data-bup-purchased]').forEach(function (el) { el.textContent = formatDay(today); });
    box.querySelectorAll('[data-bup-shipped]').forEach(function (el) { el.textContent = formatDay(shipDay); });

    // Geri sayım odsport'taki gibi: bir sonraki kargo gününün kesim saatine kalan süre, 24 saatlik döngüde (SS:DD:sn).
    var cutoffRow = box.querySelector('[data-bup-cutoff]');
    var plainRow = box.querySelector('[data-bup-plain]');
    if (cutoffRow) {
      cutoffRow.hidden = false;
      if (plainRow) plainRow.hidden = true;
      var dayGap = Math.round((shipDay.getTime() - today.getTime()) / 86400000);
      var left = Math.max(0, dayGap * 86400 + cutoff * 3600 - (now.hour * 3600 + now.minute * 60 + now.second)) % 86400;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var label = pad(Math.min(23, Math.floor(left / 3600))) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      cutoffRow.querySelectorAll('[data-bup-time]').forEach(function (el) { el.textContent = label; });
    }
  }

  function initProof(root) {
    if (root.dataset.bupReady) return;
    root.dataset.bupReady = 'true';

    // Kargo kutusunu buton alanının en altına (Sepete Ekle / Hemen Satın Al / Favorilere Ekle'nin altına) taşı.
    var box = root.querySelector('[data-bup-delivery]');
    if (box) root.bupBox = box;
    if (box && root.dataset.position === 'after_buttons') {
      var submit = document.getElementById('ProductSubmitButton-' + root.dataset.bupSection);
      var buttons = submit && submit.closest('.product-form__buttons');
      if (buttons) buttons.appendChild(box);
    }
    updateDelivery(root);
    setInterval(function () { updateDelivery(root); }, 1000);
  }

  var BIS_STORAGE_KEY = 'bupStokBildirim';

  // 05XX..., 5XX..., 905XX... girişlerini 905XXXXXXXXX biçimine çevirir (Zühre stok-bildirim-formu ile aynı).
  function normalizePhone(value) {
    var digits = value.replace(/\D/g, '');
    if (digits.length === 12 && digits.indexOf('90') === 0) digits = digits.slice(2);
    if (digits.length === 11 && digits.charAt(0) === '0') digits = digits.slice(1);
    if (digits.length === 10 && digits.charAt(0) === '5') return '90' + digits;
    return null;
  }

  function bisCode(variant) {
    return String((variant.barcode || '').trim() || (variant.sku || '').trim() || variant.id).replace(/,/g, '');
  }

  // Tükendi durumunda tema butonlarını gizleyip yerine "Stoğa gelince haber ver" butonlarını gösterir.
  // Tema varyant değişiminde butonları yeniden çizebildiği için yerleşim her seferinde kontrol edilir.
  function placeBisTrigger(trigger, themeButton) {
    if (themeButton && trigger.nextElementSibling !== themeButton) {
      themeButton.parentNode.insertBefore(trigger, themeButton);
    }
  }

  function syncBisButtons(root) {
    var sectionId = root.dataset.bupSection;
    var soldOut = root.dataset.available !== 'true';
    var themeSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
    var sticky = document.querySelector('#ProductStickyCart-' + sectionId + ' .product-bar__submit:not(.bup-bis__trigger)');

    placeBisTrigger(root.bupTrigger, themeSubmit);
    if (sticky && !root.bupStickyTrigger) {
      root.bupStickyTrigger = root.bupTrigger.cloneNode(true);
      root.bupStickyTrigger.className = 'button product-bar__submit button--filled capitalize bup-bis__trigger bup-bis__trigger--sticky';
      root.bupStickyTrigger.addEventListener('click', root.bupOpen);
    }
    if (root.bupStickyTrigger) placeBisTrigger(root.bupStickyTrigger, sticky);

    [root.bupTrigger, root.bupStickyTrigger].forEach(function (btn) { if (btn) btn.hidden = !soldOut; });
    [themeSubmit, sticky].forEach(function (btn) { if (btn) btn.classList.toggle('bup-bis-hidden', soldOut); });
    // Tükendi durumunda miktar seçici ve "Hemen satın al" da gizlenir, buton tam genişlik olur.
    if (themeSubmit) themeSubmit.parentNode.classList.toggle('bup-bis-soldout', soldOut);
  }

  function initBis(root) {
    if (root.dataset.bupReady) return;
    root.dataset.bupReady = 'true';
    var sectionId = root.dataset.bupSection;
    var dialog = root.querySelector('dialog');
    var form = dialog && dialog.querySelector('form');
    var trigger = root.querySelector('[data-bup-bis-open]');
    if (!dialog || !form || !trigger) return;

    var tagsInput = form.querySelector('[data-bup-bis-tags]');
    var emailInput = form.querySelector('[data-bup-bis-email]');
    var phoneInput = form.querySelector('[data-bup-bis-phone]');
    var errorEl = form.querySelector('[data-bup-bis-error]');
    var bodyEl = form.querySelector('[data-bup-bis-body]');
    var successEl = form.querySelector('[data-bup-bis-success]');
    var customerEmail = emailInput.value;

    function openDialog() {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('bup-bis-locked');
      if (!bodyEl.hidden) phoneInput.focus({ preventScroll: true });
    }
    function closeDialog() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('bup-bis-locked');
    });
    root.bupTrigger = trigger;
    // Butondan her açılışta numara formu gelsin: önceki gönderimin teşekkür / hata mesajı temizlenir
    // (ör. bir bedene kayıt olduktan sonra başka beden için tekrar açıldığında).
    function openForm() {
      bodyEl.hidden = false;
      successEl.hidden = true;
      errorEl.hidden = true;
      form.querySelectorAll('[data-bup-bis-server-error]').forEach(function (el) { el.remove(); });
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.classList.remove('loading');
      openDialog();
    }
    root.bupOpen = openForm;
    trigger.addEventListener('click', openForm);
    syncBisButtons(root);
    dialog.querySelector('[data-bup-bis-close]').addEventListener('click', closeDialog);
    // Popup dışına (arka plana) tıklayınca kapat.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closeDialog(); });

    function showSuccess() {
      bodyEl.hidden = true;
      successEl.hidden = false;
    }
    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    // Gönderimden sonra Shopify ürüne geri döner: başarılıysa adreste customer_posted=true olur, hata varsa
    // snippet Shopify'ın form hatasını [data-bup-bis-server-error] içine yazar. İkisinde de popup açılır.
    var submittedHere = false;
    try {
      submittedHere = sessionStorage.getItem(BIS_STORAGE_KEY) === '1';
      sessionStorage.removeItem(BIS_STORAGE_KEY);
    } catch (e) {}
    if (submittedHere && window.location.search.indexOf('customer_posted=true') !== -1) {
      showSuccess();
      openDialog();
    } else if (form.querySelector('[data-bup-bis-server-error]')) {
      openDialog();
    }

    // Form arka planda (fetch) gönderilmez: mağazada Shopify CAPTCHA'sı açık ve token'ı yalnızca normal
    // gönderimde ekliyor (fetch ile gönderilince 400 "Missing CAPTCHA token" dönüyor). Bu yüzden değerler
    // forma yazılır ve gönderim Shopify'ın CAPTCHA koduna bırakılır.
    form.addEventListener('submit', function (e) {
      var phone = normalizePhone(phoneInput.value);
      if (!phone) {
        e.preventDefault();
        // Shopify'ın CAPTCHA kodu document'ta dinliyor; geçersiz numarada onun formu göndermesini engelle.
        e.stopPropagation();
        showError('Lütfen geçerli bir cep telefonu girin (ör. 0532 123 45 67).');
        phoneInput.focus();
        return;
      }
      errorEl.hidden = true;
      tagsInput.value = tagsInput.value.replace(/,\s*wa:\d+/g, '') + ', wa:' + phone;
      emailInput.value = customerEmail || phone + '@' + emailInput.dataset.domain;
      try { sessionStorage.setItem(BIS_STORAGE_KEY, '1'); } catch (err) {}
      form.querySelector('[type="submit"]').classList.add('loading');
    });
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.variant) return;
    var variant = data.variant;
    var sectionId = data.sectionId;

    document.querySelectorAll('[data-bup-bis][data-bup-section="' + sectionId + '"]').forEach(function (root) {
      root.dataset.available = String(!!variant.available);
      syncBisButtons(root);
      // Etiket: barkod → SKU → varyant ID (snippets/bup-back-in-stock.liquid ile aynı sıra).
      var tags = root.querySelector('[data-bup-bis-tags]');
      if (tags) {
        var value = tags.dataset.prefix + bisCode(variant) + ', stok-v-' + variant.id;
        tags.value = tags.dataset.general ? tags.dataset.general + ', ' + value : value;
      }
      var label = root.querySelector('[data-bup-bis-variant]');
      if (label && label.textContent) label.textContent = ' – ' + variant.title;
    });

    document.querySelectorAll('[data-bup-proof][data-bup-section="' + sectionId + '"]').forEach(function (root) {
      root.dataset.available = String(!!variant.available);
      var delivery = root.bupBox || root.querySelector('[data-bup-delivery]');
      if (delivery) delivery.hidden = !variant.available;

      var stock = root.querySelector('.bup-proof__stock');
      var source = data.html && data.html.querySelector('.bup-proof__stock');
      if (stock && source) {
        stock.innerHTML = source.innerHTML;
        stock.hidden = source.hidden;
      }
      updateDelivery(root);
    });
  }

  function init() {
    document.querySelectorAll('[data-bup-proof]').forEach(initProof);
    document.querySelectorAll('[data-bup-bis]').forEach(initBis);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
